<template>
  <div class="government-home">
    <div class="big-title" v-text="activTitle" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;font-size: .43333rem;"></div>
    <div class="my-form">
      <form>
        <div>
          <span class="title">
            <span class="noEmpty">*</span>
            填报人名称/Name
          </span>
          <input class="input-value" v-model="name" placeholder="请输入" />
        </div>
        <div class="form-line">
          <span class="title">
            <span class="noEmpty">*</span>
            填报人联系方式/Mobile
          </span>
          <input class="input-value" v-model="contact" placeholder="请输入" />
        </div>
        <div class="form-line">
          <span class="title">
            <span class="noEmpty">*</span>
            填报人所在单位/Institution
          </span>
          <input class="input-value" v-model="institution" placeholder="请输入" />
        </div>
        <!-- add begin-->
        <!-- <div class="form-line" v-show="this.fieldIds.length>0 && this.fieldIds.indexOf('19')>-1">
          <span class="title">
            <span class="noEmpty" v-show="this.idsMaps.length>0 && this.idsMaps.indexOf('19')>-1">*</span>
             附件/Accessory：
          </span>
          <input class="input-value" v-model="todo" placeholder="请输入" />
        </div> -->
        <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('9') > -1">
          <span class="title">
            <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('9') > -1">*</span>
            感兴趣的合作领域或项目/Industry：
          </span>
          <input class="input-value" v-model="cooperation_domain" placeholder="请输入" />
        </div>
        <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('17') > -1">
          <span class="title">
            <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('17') > -1">*</span>
            备注/Remark：
          </span>
          <input class="input-value" v-model="remark" placeholder="请输入" />
        </div>
        <!-- add end-->
        <div class="form-line">
          <span class="title">
            <span class="noEmpty">*</span>
            参会人员/Participants
          </span>

          <table class="person-table" cellspacing="0" v-if="personList.length > 0">
            <tr>
              <th>姓名</th>
              <th>参加活动（序号）</th>
              <th>操作</th>
            </tr>
            <tr v-for="(item, index) in personList" :key="index">
              <td>{{ item.name }}</td>
              <td>{{ item.activityNo }}</td>
              <td><a @click="deletePerson(index)">删除</a></td>
            </tr>
          </table>

          <a class="add-person-btn" @click="addPersonPopup">+添加参会人员</a>
        </div>
        <a class="submit-btn" @click="submitForm" v-show="expireStatus == 0">确认报名</a>
      </form>
      <!-- 国家选择popup start -->
      <van-popup position="bottom" v-model="showCountryPicker">
        <van-search v-model="countrySearch" show-action label="国家" placeholder="请输入搜索关键词" @search="onSearch">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <van-picker cancel-button-text="取消" value-key="title" show-toolbar :columns="countryListT" @confirm="onConfirmPicker" @cancel="showCountryPicker = false" />
      </van-popup>
      <!-- 国家选择popup end -->
      <!-- 添加人员popup start-->
      <van-popup position="bottom" v-model="showPersonPicker" :style="{ height: '91%' }">
        <div class="add-person-popup">
          <div>
            <span class="title">
              <span class="noEmpty">*</span>
              姓名/Name
            </span>
            <input class="input-value" v-model="personForm.name" placeholder="请输入" />
          </div>
          <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('21') > -1">
            <span class="title">
              <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('21') > -1">*</span>
              性别/Gender
            </span>
            <van-radio-group v-model="personForm.sexRadio">
              <van-radio name="1">男</van-radio>
              <van-radio name="0">女</van-radio>
            </van-radio-group>
          </div>
          <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('31') > -1">
            <span class="title">
              <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('31') > -1">*</span>
              职务/Position
            </span>
            <input class="input-value" v-model="personForm.position" placeholder="请输入" />
          </div>
          <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('32') > -1">
            <span class="title">
              <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('32') > -1">*</span>
              手机/Mobile
            </span>
            <input class="input-value" v-model="personForm.mobile" placeholder="请输入" />
          </div>
          <!-- <div class="form-line">
            <span class="update-style">
              <span class="title">国籍/Nationality</span>
              <van-field :value="personForm.nationality" placeholder="请选择国家" @click="changePicker2(1)" />
            </span>
          </div> -->
          <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('3') > -1">
            <span class="title">
              <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('3') > -1">*</span>
              身份证号/ID No.
            </span>
            <input class="input-value" v-model="personForm.identify" placeholder="请输入" />
          </div>
          <!-- <div class="form-line">
            <span class="title">护照号/来往内地通行证号/Passport No./Mainland Travel Permit No.</span>
            <input class="input-value" v-model="personForm.passport" placeholder="请输入" />
          </div> -->

          <!-- add begin -->
          <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('5') > -1">
            <span class="title">
              <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('5') > -1">*</span>
              户籍地/Place of Domicile.
            </span>
            <input class="input-value" v-model="personForm.domicile" placeholder="请输入" />
          </div>
          <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('6') > -1">
            <span class="title">
              <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('6') > -1">*</span>
              民族/Nation.
            </span>
            <input class="input-value" v-model="personForm.nation" placeholder="请输入" />
          </div>
          <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('7') > -1">
            <span class="title">
              <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('7') > -1">*</span>
              会议证件类型/Place of Domicile.
            </span>
            <input class="input-value" v-model="personForm.meeting_documents_type" placeholder="请输入" />
          </div>
          <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('12') > -1">
            <span class="title">
              <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('12') > -1">*</span>
              是否安排住宿/Accommodation Yes/No.
            </span>
            <van-radio-group v-model="personForm.is_room">
              <van-radio name="1">是</van-radio>
              <van-radio name="0">否</van-radio>
            </van-radio-group>
          </div>
          <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('13') > -1">
            <span class="title">
              <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('13') > -1">*</span>
              是否用餐/Dinner Yes/No.
            </span>
            <van-radio-group v-model="personForm.is_dine">
              <van-radio name="1">是</van-radio>
              <van-radio name="0">否</van-radio>
            </van-radio-group>
          </div>
          <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('14') > -1">
            <span class="title">
              <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('14') > -1">*</span>
              是否统一乘车/Complimentary Bus Service Yes/No.
            </span>
            <van-radio-group v-model="personForm.is_car">
              <van-radio name="1">是</van-radio>
              <van-radio name="0">否</van-radio>
            </van-radio-group>
          </div>
          <!-- <div class="form-line" v-show="this.fieldIds.length>0 && this.fieldIds.indexOf('15')>-1">
            <span class="title">
                <span class="noEmpty" v-show="this.idsMaps.length>0 && this.idsMaps.indexOf('15')>-1">*</span>
                抵达时间/Arrival time.
            </span>
            <input class="input-value" v-model="personForm.arrival_time" placeholder="请输入" />
          </div>
          <div class="form-line" v-show="this.fieldIds.length>0 && this.fieldIds.indexOf('16')>-1">
            <span class="title">
                <span class="noEmpty" v-show="this.idsMaps.length>0 && this.idsMaps.indexOf('16')>-1">*</span>
                离开时间/Departure time.
            </span>
            <input class="input-value" v-model="personForm.leave_time" placeholder="请输入" />
          </div> -->
          <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('22') > -1">
            <span class="title">
              <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('22') > -1">*</span>
              备注/Remark.
            </span>
            <input class="input-value" v-model="personForm.remark" placeholder="请输入" />
          </div>
          <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('26') > -1">
            <span class="title">
              <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('26') > -1">*</span>
              办公电话/Tel.
            </span>
            <input class="input-value" v-model="personForm.tel" placeholder="请输入" />
          </div>
          <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('27') > -1">
            <span class="title">
              <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('27') > -1">*</span>
              传真/Fax.
            </span>
            <input class="input-value" v-model="personForm.fax" placeholder="请输入" />
          </div>
          <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('28') > -1">
            <span class="title">
              <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('28') > -1">*</span>
              邮箱/Email.
            </span>
            <input class="input-value" v-model="personForm.email" placeholder="请输入" />
          </div>
          <!-- add begin -->
          <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('11') > -1">
            <span class="title">
              <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('11') > -1">*</span>
              选择参加的活动/Selection of Sub-branch
            </span>
            <div class="show-activity">
              <span v-for="(item, index) in activityCheckList" :key="index">{{ item.branch_activity_name }}</span>
            </div>
            <a class="add-person-btn" @click="selectActiveBtn">+选择活动</a>
          </div>

          <div class="form-line" v-show="this.fieldIds.length > 0 && this.fieldIds.indexOf('18') > -1">
            <span class="title">
              <span class="noEmpty" v-show="this.idsMaps.length > 0 && this.idsMaps.indexOf('18') > -1">*</span>
              照片/Photo
            </span>
            <van-uploader :after-read="afterRead" v-model="fileList" multiple :max-count="1" :max-size="3 * 1024 * 1024" @oversize="onOversize" />
            <input type="hidden" v-model="personForm.portrait_id" />
          </div>
          <div class="submit-person">
            <a class="submit-person-btn cancel-btn" @click="cancelPerson">返回</a>
            <a class="submit-person-btn" @click="addPerson">保存</a>
          </div>
        </div>
      </van-popup>
      <!-- 添加人员popup end-->

      <!-- 个人信息国籍选择popup start -->
      <van-popup position="bottom" v-model="showCountryPickerPerson">
        <van-search v-model="countrySearch" show-action label="国家" placeholder="请输入搜索关键词" @search="onSearch">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <van-picker cancel-button-text="取消" value-key="title" show-toolbar :columns="countryListT" @confirm="onConfirmPickerPerson" @cancel="showCountryPickerPerson = false" />
      </van-popup>
      <!-- 个人信息国籍选择popup end -->

      <!-- 活动列表popup start -->

      <van-popup position="bottom" v-model="showActivityPicker" :style="{ height: '91%' }">
        <div class="activity-popup">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div class="activity-info" v-for="(item, index) in activityListT" :key="index">
              <van-checkbox-group v-model="checkedResult">
                <van-checkbox :name="index" shape="square" @click="checkActivityCorrect(item, index)" ref="checkbox">{{ item.branch_activity_name }}</van-checkbox>
                <div class="activity-detail">
                  <span>活动时间：{{ item.show_sta_date }}&nbsp;&nbsp;{{ item.sta_time }} - {{ item.end_time }}</span>
                  <span>活动地址：{{ item.address }}</span>
                </div>
              </van-checkbox-group>
            </div>
          </van-list>
          <div class="submit-person">
            <a class="submit-person-btn cancel-btn" @click="cancelActivity">返回</a>
            <a class="submit-person-btn" @click="addActivity">确认</a>
          </div>
        </div>
      </van-popup>
      <!-- 活动列表popup start -->
      <!-- 防疫提示popup start -->
      <van-dialog v-model="epidemicShow" title="温馨提示" :beforeClose="chargeBtn" style="height:51%;overflow: scroll;padding: 15px;">
        <div>
          <p>欢迎您报名参加2022粤港澳大湾区全球招商大会。</p>
          <p>21日上午的南沙投资考察活动已更改为政策宣讲会，22日的投资考察活动也已更新路线，请您在本页面提交报名信息后，在微信搜索大会小程序（2022粤港澳大湾区全球招商大会），登录后填报您的活动意向。</p>
          <p>期待您的参会！</p>
          <!-- <p>1.参会人员须持48小时新冠病毒核酸检测阴性证明参会；</p>
          <p>2.会前7天内有境内中高风险区、境外地区旅居史人员，未排除感染风险者不能参会；</p>
          <p>3.中高风险区所在县（市、区、旗）的其他地区（低风险地区）人员，完成核酸检测三天两检，并做好健康监测，检测结果为阴性后可以参会；</p>
          <p>4.会前7天出现发热、干咳、乏力、咽痛、嗅（味）觉减退、腹泻等可自我感知或可临床识别的症状与体征，未经就医诊断排除感染新冠病毒的不能参会；</p>
          <p>5.已治愈出院的确诊病例或已解除集中隔离医学观察的无症状感染者，尚在随访或医学观察期内的不能参会；</p>
          <p>6.被判定为新型冠状病毒感染者（确诊病例及无症状感染者）、疑似病例的密切接触者不能参会；</p>
          <p>7.按照无接种禁忌症者应接尽接的原则，所有参会人员均应全程接种新冠疫苗，未全程接种者不得参会；存在接种禁忌但又确需参加的人员，请提前向大会组委会报备；</p>
          <p>8.最终确认的参会人员须执行大会期间国家和属地疫情防控政策。</p> -->
          <!-- <span>&#12288;&#12288;按照“谁派出、谁监测、谁负责”的原则，严格落实参会人员健康管理主体责任。
            由各部门各单位对负责组织的参会人员（含参会车辆驾驶员，下同）开展流行病学史筛查、健康监测、核酸检测、疫苗接种等工作，做到应查尽查、应检尽检、不漏一人。
            健康筛查不合格者不得参会。</span>
        
        <p>一、有下列情形的，不得参会或换人参会</p>
         <span>&#12288;&#12288;1.在会前14天内有境内中高风险地区、港台地区、国外旅行史或居住史；<br>
                &#12288;&#12288;2.被判定为新型冠状病毒感染者（确诊病例及无症状感染者）、疑似病例的密切接触者，原则上不得参会；<br>
                &#12288;&#12288;3.具有境内中高风险地区所在行政区（县）旅居史、接触史人员未排除感染风险者不得参会；<br>
                &#12288;&#12288;4.已治愈出院的确诊病例或已解除集中隔离医学观察的无症状感染者，尚在随访或医学观察期内的不得参会。
          </span>       
        <p>二、会前健康监测</p>
          <span>&#12288;&#12288;参会人员自接到会议通知之日起，采取自查自报的方式进行健康监测，每天进行体温测量。如有发热、乏力、咳嗽、咽痛、腹泻、呕吐、嗅觉或味觉减退等症状，应及时就诊，及时报告有关情况。           
          </span>
        <p>三、核酸检测</p>
          <span>&#12288;&#12288;参会人员由所属单位负责组织在会前24小时内进行新冠病毒核酸检测，检测结果为阴性者方可参会。检测结果交参会人员所属单位存档。核酸检测后，原则上进行闭环管理，避免非必要活动，不接触与会议无关人员，不进入与会议无关场所，严格做好个人防护，直至会议结束。           
          </span>
        <p>四、疫苗接种</p>
          <span>&#12288;&#12288;按照无接种禁忌症者应接尽接的原则，所有参会人员均应全程接种新冠疫苗，未全程接种者不得参会；存在接种禁忌但又确需参加的人员，请提前向大会组委会报备。</span> -->
          <br />
          <br />
          <van-checkbox v-model="readChecked" shape="square">我已阅读并确认知晓以上提醒内容</van-checkbox>
        </div>
      </van-dialog>
      <!-- 防疫提示popup end -->
    </div>
  </div>
</template>
<script>
import { Tag, Field, Picker, Search, Popup, Toast, Cell, CellGroup, List, Radio, RadioGroup, Checkbox, CheckboxGroup, Dialog, Uploader } from 'vant';
//导入CSS
import '@/assets/css/main.less';
import { isMobile, isIdCard } from '@/utils/validate';
import { compressImage } from '@/utils/compressImage'; // 图片压缩方法
export default {
  components: {
    [Toast.name]: Toast,
    [Tag.name]: Tag,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Search.name]: Search,
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [List.name]: List,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Dialog.name]: Dialog,
    [Dialog.Component.name]: Dialog.Component,
    [Uploader.name]: Uploader,
  },

  data() {
    return {
      epidemicShow: false,
      readChecked: false,
      name: '',
      contact: '',
      institution: '',
      countryPerson: '',
      countrySearch: '',
      countrySearchPerson: '',
      cooperation_domain: '',
      remark: '',
      personForm: { sexRadio: '1', portrait_id: '' },
      countryList: [], //数据库查
      countryListT: [], //临时变量
      personList: [],
      activityCheckList: [],
      showCountryPicker: false,
      showCountryPickerPerson: false,
      showPersonPicker: false,
      showActivityPicker: false,
      typeFlag: '',
      checkedResult: [],
      activityList: [],
      activityListT: [],
      fileList: [],
      loading: false,
      finished: false,
      loadNum: 10,
      actId: this.$route.query.actId,
      fieldIds: [],
      idsMaps: [],
      activTitle: '',
      expireStatus: 0,
    };
  },

  created() {
    //获取活动结束接口
    this.getActExipire();
    //获取标题字段接口
    this.getActivTitle();
    //获取国家的接口
    this.getCountry();
    //获取活动的接口
    this.getActivity();
    //获取展示字段接口
    this.getShowLable();
    //获取必填字段接口
    this.getNecessaryLable();
  },

  methods: {
    //获取活动结束接口
    getActExipire() {
      const that = this;
      let params = {
        actId: this.actId,
      };
      params = require('querystring').stringify(params);
      this.$axios.post(this.COMMON.baseURL + '/activity/toActExipire', params).then(function(res) {
        if (res.data.status == 200) {
          if (res.data.data == 1) {
            that.expireStatus = 1;
            Dialog.alert({
              title: '温馨提示',
              message: '本次活动报名已经结束',
            });
          }
        }
      });
    },
    //获取标题字段接口
    getActivTitle() {
      const that = this;
      let params = {
        actId: this.actId,
      };
      params = require('querystring').stringify(params);
      this.$axios.post(this.COMMON.baseURL + '/activity/getActivTitle', params).then(function(res) {
        if (res.data.status == 200) {
          that.activTitle = res.data.data;
        }
      });
    },
    //获取国家的接口
    getCountry() {
      const that = this;
      this.$axios.get(this.COMMON.baseURL + '/activity/getCountryAreas').then(function(res) {
        if (res.data.status == 200) {
          that.countryList = res.data.data;
        }
      });
    },
    //获取活动的接口
    getActivity() {
      const that = this;
      let params = {
        actId: this.actId,
      };
      params = require('querystring').stringify(params);
      // this.$axios.get(this.COMMON.baseURL + '/activity/getBranchActList').then(function(res) {
      this.$axios.post(this.COMMON.baseURL + '/activity/getBranchActList', params).then(function(res) {
        if (res.data.status == 200) {
          that.activityList = res.data.data;
          let date, month, day;
          for (let obj of that.activityList) {
            date = new Date(obj.sta_date.replace(/-/g, '/'));
            month = date.getMonth() + 1;
            day = date.getDate();
            obj.show_sta_date = month + '-' + day;
          }
        }
      });
    },
    //获取展示字段接口
    getShowLable() {
      const that = this;
      let params = {
        actId: this.actId,
      };
      params = require('querystring').stringify(params);
      this.$axios.post(this.COMMON.baseURL + '/activity/toShowLable', params).then(function(res) {
        if (res.data.status == 200) {
          that.fieldIds = res.data.data.split(',');
        }
      });
    },
    //获取必填字段接口
    getNecessaryLable() {
      const that = this;
      let params = {
        actId: this.actId,
      };
      params = require('querystring').stringify(params);
      this.$axios.post(this.COMMON.baseURL + '/activity/toNecessaryLable', params).then(function(res) {
        if (res.data.status == 200) {
          that.idsMaps = res.data.data;
        }
      });
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求

      setTimeout(() => {
        for (let i = this.loadNum - 10; i < this.loadNum; i++) {
          if (i < this.activityList.length) {
            this.activityListT.push(this.activityList[i]);
          }
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.activityListT.length >= this.activityList.length) {
          this.finished = true;
          this.loadNum = 10;
        } else {
          this.loadNum = this.loadNum + 10;
        }
      }, 100);
    },
    initParam() {
      this.personForm = { sexRadio: '1' };
      this.activityCheckList = [];
      this.checkedResult = [];
      this.fileList = [];
    },
    changePicker1(flag) {
      const that = this;
      this.typeFlag = flag;

      that.countryListT = that.countryList;
      if (flag === 1) {
        this.countrySearch = '';
      }
      this.showCountryPicker = true;
    },
    changePicker2(flag) {
      const that = this;
      this.typeFlag = flag;
      that.countryListT = that.countryList;
      if (flag === 1) {
        this.countrySearch = '';
      }
      this.showCountryPickerPerson = true;
    },
    onConfirmPicker(obj) {
      if (this.typeFlag === 1) {
        this.country = obj.name;
        this.countryId = obj.id;
      }
      this.showCountryPicker = false;
    },

    onConfirmPickerPerson(obj) {
      if (this.typeFlag === 1) {
        this.personForm.nationality = obj.name;
        this.personForm.nationalityId = obj.id;
      }
      this.showCountryPickerPerson = false;
    },

    addPersonPopup() {
      this.showPersonPicker = true;
    },
    selectActiveBtn() {
      this.showActivityPicker = true;
    },

    addPerson() {
      let activityCheckList = this.activityCheckList;
      let activityNo = [];
      let activityId = [];
      let activityNameAndNo = '';
      if (this.personForm.name == '' || this.personForm.name == null || this.personForm.name == undefined) {
        Dialog.alert({
          message: '姓名不能为空',
        });
        return false;
      }
      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('31') > -1 && (this.personForm.position == '' || this.personForm.position == null || this.personForm.position == undefined)) {
        Dialog.alert({
          message: '职务不能为空',
        });
        return false;
      }
      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('32') > -1 && (this.personForm.mobile == '' || this.personForm.mobile == null || this.personForm.mobile == undefined)) {
        Dialog.alert({
          message: '手机号不能为空',
        });
        return false;
      }

      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('3') > -1 && (this.personForm.identify == '' || this.personForm.identify == null || this.personForm.identify == undefined)) {
        Dialog.alert({
          message: '身份证号不能为空',
        });
        return false;
      } else if (this.idsMaps.length > 0 && this.idsMaps.indexOf('3') > -1 && !isIdCard(this.personForm.identify)) {
        Dialog.alert({
          message: '身份证号不正确',
        });
        return false;
      }

      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('21') > -1 && (this.personForm.sexRadio == '' || this.personForm.sexRadio == null || this.personForm.sexRadio == undefined)) {
        Dialog.alert({
          message: '性别不能为空',
        });
        return false;
      }

      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('5') > -1 && (this.personForm.domicile == '' || this.personForm.domicile == null || this.personForm.domicile == undefined)) {
        Dialog.alert({
          message: '户籍地不能为空',
        });
        return false;
      }

      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('6') > -1 && (this.personForm.nation == '' || this.personForm.nation == null || this.personForm.nation == undefined)) {
        Dialog.alert({
          message: '民族不能为空',
        });
        return false;
      }

      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('7') > -1 && (this.personForm.meeting_documents_type == '' || this.personForm.meeting_documents_type == null || this.personForm.meeting_documents_type == undefined)) {
        Dialog.alert({
          message: '会议证件类型不能为空',
        });
        return false;
      }

      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('12') > -1 && (this.personForm.is_room == '' || this.personForm.is_room == null || this.personForm.is_room == undefined)) {
        Dialog.alert({
          message: '是否安排住宿不能为空',
        });
        return false;
      }

      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('13') > -1 && (this.personForm.is_dine == '' || this.personForm.is_dine == null || this.personForm.is_dine == undefined)) {
        Dialog.alert({
          message: '是否用餐不能为空',
        });
        return false;
      }

      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('14') > -1 && (this.personForm.is_car == '' || this.personForm.is_car == null || this.personForm.is_car == undefined)) {
        Dialog.alert({
          message: '是否统一乘车不能为空',
        });
        return false;
      }

      // if ((this.idsMaps.length>0 && this.idsMaps.indexOf('15')>-1) && (this.personForm.arrival_time == '' || this.personForm.arrival_time == null || this.personForm.arrival_time == undefined)) {
      //   Dialog.alert({
      //     message: '抵达时间不能为空',
      //   });
      //   return false;
      // }

      // if ((this.idsMaps.length>0 && this.idsMaps.indexOf('16')>-1) && (this.personForm.leave_time == '' || this.personForm.leave_time == null || this.personForm.leave_time == undefined)) {
      //   Dialog.alert({
      //     message: '离开时间不能为空',
      //   });
      //   return false;
      // }

      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('22') > -1 && (this.personForm.remark == '' || this.personForm.remark == null || this.personForm.remark == undefined)) {
        Dialog.alert({
          message: '备注不能为空',
        });
        return false;
      }

      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('26') > -1 && (this.personForm.tel == '' || this.personForm.tel == null || this.personForm.tel == undefined)) {
        Dialog.alert({
          message: '办公电话不能为空',
        });
        return false;
      }

      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('27') > -1 && (this.personForm.fax == '' || this.personForm.fax == null || this.personForm.fax == undefined)) {
        Dialog.alert({
          message: '传真不能为空',
        });
        return false;
      }

      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('28') > -1 && (this.personForm.email == '' || this.personForm.email == null || this.personForm.email == undefined)) {
        Dialog.alert({
          message: '邮箱不能为空',
        });
        return false;
      }

      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('11') > -1 && this.activityCheckList.length <= 0) {
        Dialog.alert({
          message: '参加的活动不能为空',
        });
        return false;
      }
      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('18') > -1 && (this.personForm.portrait_id == '' || this.personForm.portrait_id == null || this.personForm.portrait_id == undefined)) {
        Dialog.alert({
          message: '请上传您的照片或者图片还未上传完毕，请等待',
        });
        return false;
      }
      for (let i = 0; i < activityCheckList.length; i++) {
        activityNameAndNo = activityCheckList[i].branch_activity_name;
        activityNameAndNo = activityNameAndNo.split('.');
        activityNo.push(activityNameAndNo[0]);
        activityId.push(activityCheckList[i].branch_id);
      }

      this.personList.push({ name: this.personForm.name, identity_card: this.personForm.identify, dept: this.personForm.position, phone: this.personForm.mobile, sex: this.personForm.sexRadio, activityNo: activityNo.join(','), portrait_id: this.personForm.portrait_id, activityId: activityId, domicile: this.personForm.domicile, nation: this.personForm.nation, meeting_documents_type: this.personForm.meeting_documents_type, is_room: this.personForm.is_room, is_dine: this.personForm.is_dine, is_car: this.personForm.is_car, remark: this.personForm.remark, tel: this.personForm.tel, fax: this.personForm.fax, email: this.personForm.email });
      this.showPersonPicker = false;
      this.initParam();
    },
    cancelPerson() {
      this.showPersonPicker = false;
    },
    addActivity() {
      this.activityCheckList = [];
      let checkedResult = this.checkedResult;
      let activityList = this.activityList;
      for (let i = 0; i < activityList.length; i++) {
        for (let j = 0; j < checkedResult.length; j++) {
          if (i == checkedResult[j]) {
            this.activityCheckList.push(activityList[i]);
          }
        }
      }

      this.showActivityPicker = false;
    },
    cancelActivity() {
      this.showActivityPicker = false;
    },

    submitForm() {
      const that = this;
      let personList = this.personList;

      if (this.name == '' || this.name == null || this.name == undefined) {
        Dialog.alert({
          message: '填报人名称不能为空',
        });
        return false;
      }

      if (this.contact == '' || this.contact == null || this.contact == undefined) {
        Dialog.alert({
          message: '填报人联系方式不能为空',
        });
        return false;
      }

      if (this.institution == '' || this.institution == null || this.institution == undefined) {
        Dialog.alert({
          message: '所在单位不能为空',
        });
        return false;
      }
      // if ((this.idsMaps.length>0 && this.idsMaps.indexOf('19')>-1)&&(this. == '' || this. == null || this. == undefined)) {
      //   Dialog.alert({
      //     message: '请选择附件',
      //   });
      //   return false;
      // }

      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('9') > -1 && (this.cooperation_domain == '' || this.cooperation_domain == null || this.cooperation_domain == undefined)) {
        Dialog.alert({
          message: '感兴趣的合作领域或项目不能为空',
        });
        return false;
      }
      if (this.idsMaps.length > 0 && this.idsMaps.indexOf('17') > -1 && (this.remark == '' || this.remark == null || this.remark == undefined)) {
        Dialog.alert({
          message: '备注不能为空',
        });
        return false;
      }

      // if (this.personList.length <= 0) {
      //   Dialog.alert({
      //     message: '报名人员不能为空',
      //   });
      //   return false;
      // }

      //确认弹框
      Dialog.confirm({
        title: '提示',
        message: '是否确认报名',
      })
        .then(() => {
          // on confirm
          let params = {
            actId: this.actId,
            count: personList.length,
            //填报人名称
            filler: this.name,
            //填报人联系方式
            fillerphone: this.contact,
            //填报人所在单位
            'cusBaseInfo.cus_name': this.institution,
            //begin
            // todo
            'cusBaseInfo.cooperation_domain': this.cooperation_domain,
            'cusBaseInfo.remark': this.remark,
            fieldValues: this.fieldIds,
            //end
            applySource: 5,
          };

          for (let i = 0; i < personList.length; i++) {
            let contentName = '';
            let identityCard = '';
            let sex = '';
            let dept = '';
            let phone = '';
            let branch_ids = '';
            let portrait_id = '';

            //begin
            let domicile = '';
            domicile += ['content' + parseInt(i + 1) + '.domicile'];
            params[domicile] = personList[i].domicile;

            let nation = '';
            nation += ['content' + parseInt(i + 1) + '.nation'];
            params[nation] = personList[i].nation;

            let meeting_documents_type = '';
            meeting_documents_type += ['content' + parseInt(i + 1) + '.meeting_documents_type'];
            params[meeting_documents_type] = personList[i].meeting_documents_type;

            let is_room = '';
            is_room += ['content' + parseInt(i + 1) + '.is_room'];
            params[is_room] = personList[i].is_room;

            let is_dine = '';
            is_dine += ['content' + parseInt(i + 1) + '.is_dine'];
            params[is_dine] = personList[i].is_dine;

            let is_car = '';
            is_car += ['content' + parseInt(i + 1) + '.is_car'];
            params[is_car] = personList[i].is_car;

            let remark = '';
            remark += ['content' + parseInt(i + 1) + '.remark'];
            params[remark] = personList[i].remark;

            let tel = '';
            tel += ['contacter' + parseInt(i + 1) + '.tel'];
            params[tel] = personList[i].tel;

            let fax = '';
            fax += ['contacter' + parseInt(i + 1) + '.fax'];
            params[fax] = personList[i].fax;

            let email = '';
            email += ['contact' + parseInt(i + 1) + '.email'];
            params[email] = personList[i].email;
            // arrival_time
            // leave_time
            //end

            //姓名
            contentName += ['contacter' + parseInt(i + 1) + '.name'];
            params[contentName] = personList[i].name;

            // 身份证号
            identityCard += ['content' + parseInt(i + 1) + '.identity_card'];
            params[identityCard] = personList[i].identity_card;

            //性别
            sex += ['content' + parseInt(i + 1) + '.sex'];
            params[sex] = personList[i].sex;
            //职务
            dept += ['contact' + parseInt(i + 1) + '.dept'];
            params[dept] = personList[i].dept;
            //手机号
            phone += ['contacter' + parseInt(i + 1) + '.phone'];
            params[phone] = personList[i].phone;

            //活动序号
            branch_ids += ['branch_ids' + parseInt(i + 1)];
            params[branch_ids] = personList[i].activityId;

            //头像id
            portrait_id += ['content' + parseInt(i + 1) + '.portrait_id'];
            params[portrait_id] = personList[i].portrait_id;
          }

          this.$axios.defaults.headers = {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          };
          params = require('querystring').stringify(params);
          // 加载框
          Toast.loading({
            duration: 0,
            message: '正在提交...',
          });

          this.$axios
            .post(this.COMMON.baseURL + '/activity/govApply', params)
            .then(function(res) {
              if (res.data.status == 200) {
                //关闭加载
                Toast.clear();
                that.$router.push({
                  path: '/sucesssPage',
                });
              } else {
                //关闭加载
                Toast.clear();
                that.$router.push({
                  path: '/errorPage',
                });
              }
            })
            .catch(() => {
              Toast.clear();
              that.$router.push({
                path: '/errorPage',
              });
            });
        })
        .catch(() => {
          // on cancel
        });
    },

    onSearch() {
      let countrySearch = this.countrySearch;
      let countryListT = this.countryListT;
      let listTemp = [];

      for (var countryName of countryListT) {
        if (countryName.search(countrySearch) != -1) {
          listTemp.push(countryName);
        }
      }
      this.countryListT = listTemp;
    },
    deletePerson(index) {
      for (let i = 0; i < this.personList.length; i++) {
        if (i === index) {
          this.personList.splice(i, 1);
        }
      }
    },
    checkActivityCorrect(item, checkedIndex) {
      //获取当前的活动分支id
      let thisActBranchId = item.branch_id;
      // 获取总的活动列表数据 -- 获取当前已checked的活动分支
      let allActivity = this.activityListT;
      let checkedList = this.checkedResult; //数据是双向绑定的
      let checkBranchIds = []; // 已经checked的分支id

      // 根据checkedId 获得勾上了的活动分支数组
      checkedList.forEach(element => {
        let index = element;
        let branchId = allActivity[index].branch_id;
        checkBranchIds.push(branchId);
      });

      // 进行时间周期判断
      // 返回 true 的时候，即将其纳入选中，此时需要分析是否时间有冲突
      // 返回 false的时候，即将其移除选中，此时不需要分析是否冲突
      let isContains = checkBranchIds.includes(thisActBranchId);
      if (isContains) {
        // 先获取当前选中的分支时间
        let thisStartDateTime = this.getStartDateTime(item);
        let thisEndDateTime = this.getEndDateTime(item);
        if (this.compareDateTime(thisStartDateTime, thisEndDateTime)) {
          Dialog.alert({
            message: '该活动的开始时间比结束时间还大，请确认清楚',
          });
          return;
        }
        // 进入选中的活动分支判断环节--循环选中的分支进行判断
        checkedList.forEach(element => {
          let index = element;
          let branchId = allActivity[index].branch_id;
          let baranName = allActivity[index].branch_activity_name;
          if (branchId !== thisActBranchId) {
            // 不用判断自己
            let forStartDateTime = this.getStartDateTime(allActivity[index]);
            let forEndDateTime = this.getEndDateTime(allActivity[index]);

            // 当前选中的分支活动，开始时间是否与此活动冲突:前面的判断已默认分支的结束时间比开始时间大
            // 分支的开始时间大于【循环的分支】的结束时间
            if (this.compareDateTime(thisStartDateTime, forEndDateTime)) {
              return;
            }
            // 分支的结束时间小于【循环的分支】的开始时间
            if (this.compareDateTime(forStartDateTime, thisEndDateTime)) {
              return;
            }

            Dialog.alert({
              message: '所选择的分支活动与"' + baranName + '"的活动时间有冲突',
            });
            this.$refs.checkbox[checkedIndex].toggle(false);
          }
        });
      }
    },
    getStartDateTime(item) {
      let thisStaDate = item.sta_date;
      let thisStaTime = item.sta_time;
      let thisStartDateTime = thisStaDate.replace('00:00:00', thisStaTime);
      return thisStartDateTime;
    },
    getEndDateTime(item) {
      let thisEndDate = item.end_date;
      let thisendTime = item.end_time;
      let thisEndDateTime = thisEndDate.replace('00:00:00', thisendTime);
      return thisEndDateTime;
    },
    compareDateTime(date1, date2) {
      // 判断参数1是否比参数2大
      date1 = date1.replace(/：/g, ':');
      date2 = date2.replace(/：/g, ':');
      var oDate1 = new Date(date1.replace(/-/g, '/'));
      var oDate2 = new Date(date2.replace(/-/g, '/'));
      if (oDate1.getTime() >= oDate2.getTime()) {
        return true;
      } else {
        return false;
      }
    },
    afterRead(file) {
      // console.log(file);
      // 此时可以自行将文件上传至服务器
      let that = this;
      let count = this.personList.length;

      let config = {
        width: 400 * 2, // 压缩后图片的宽
        height: 500 * 2, // 压缩后图片的高
        quality: 0.9, // 压缩后图片的清晰度，取值0-1，值越小，所绘制出的图像越模糊
      };

      //调用压缩方法
      compressImage(file.file, config).then(result => {
        // result 为压缩后二进制文件
        //返回压缩后的图片
        Toast.loading({
          duration: 3600000, // 持续展示 toast
          message: '加载中...',
          forbidClick: true,
        });
        let params = {};
        params.headerPic = result;
        params.contacterId = parseInt(count + 1);
        this.$axios.defaults.headers = {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        };
        params = require('querystring').stringify(params);
        this.$axios
          .post(this.COMMON.baseURL + '/activity/uploadFile', params)
          .then(function(res) {
            Toast.clear();
            if (res.status == 200) {
              let photoId = res.data.fileRecord.di_id;
              that.personForm.portrait_id = photoId;
              console.log(that.personForm.portrait_id);
              if (photoId == undefined || photoId == null || photoId == '') {
                Dialog.alert({
                  message: '图片上传失败',
                });
              }
            } else {
              Dialog.alert({
                message: '图片上传失败',
              });
            }
          })
          .catch(function(error) {
            // 请求失败处理
            Toast.clear();
            that.personForm.portrait_id = '';
            that.fileList = [];
            Dialog.alert({
              message: '图片上传失败,请重新上传',
            });
          });
      });
    },
    onOversize(file) {
      Dialog.alert({
        message: '图片上不能超过3M',
      });
    },
    chargeBtn(action, done) {
      if (!this.readChecked) {
        done(false);
        Dialog.alert({
          message: '请阅读温馨提示并勾选',
        });
        return;
      } else {
        done();
      }
    },
  },
};
</script>
